var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isLoading
    ? _c(
        "v-container",
        { staticClass: "flex-column", attrs: { fluid: "" } },
        [
          _c("h1", { staticClass: "page-title page-title__primary mb-4" }, [
            _vm._v("Параметры прогноза"),
          ]),
          _c(
            "v-form",
            [
              _c("v-text-field", {
                attrs: {
                  label: "Количество шагов",
                  type: "number",
                  outlined: "",
                },
                model: {
                  value: _vm.predictParams.nsteps,
                  callback: function ($$v) {
                    _vm.$set(_vm.predictParams, "nsteps", $$v)
                  },
                  expression: "predictParams.nsteps",
                },
              }),
              _c("v-text-field", {
                attrs: {
                  label: "Длительность шага в днях",
                  type: "number",
                  outlined: "",
                },
                model: {
                  value: _vm.predictParams.step_days,
                  callback: function ($$v) {
                    _vm.$set(_vm.predictParams, "step_days", $$v)
                  },
                  expression: "predictParams.step_days",
                },
              }),
              _vm.optimizeTask.type === "wells"
                ? _c("v-select", {
                    attrs: {
                      label: "Параметр для отбора скважин",
                      items: _vm.wellPredictParams,
                      outlined: "",
                    },
                    model: {
                      value: _vm.predictParams.wells_predict_param,
                      callback: function ($$v) {
                        _vm.$set(_vm.predictParams, "wells_predict_param", $$v)
                      },
                      expression: "predictParams.wells_predict_param",
                    },
                  })
                : _vm._e(),
              _vm.optimizeTask.type === "wells"
                ? _c("v-text-field", {
                    attrs: {
                      label: "Количество новых скважин",
                      type: "number",
                      outlined: "",
                    },
                    model: {
                      value: _vm.predictParams.wells_count,
                      callback: function ($$v) {
                        _vm.$set(_vm.predictParams, "wells_count", $$v)
                      },
                      expression: "predictParams.wells_count",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }